declare var Reflect: any;
var __decorate: any = (this && this.__decorate) || function (decorators: any, target: any, key: any, desc: any) {
    var c = arguments.length,
        r = (c < 3) ? target : (desc === null) ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;

    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") {
        r = Reflect.decorate(decorators, target, key, desc);
    } else {
        for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) {
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
            }
        }
    }

    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

const __skipExtends = {
    "__metadata": true,
    "__typeName": true,
    "__componentFactory": true,
};

var __extends: any = (this && this.__extends) || function (d: any, b: any) {
    for (var p in b) {
        if (b.hasOwnProperty(p) && __skipExtends[p] !== true) {
            d[p] = b[p];
        }
    }

    function __() {
        this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new (__ as any)());
};

var __assign = (Object as any).assign || function (t: any) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) {
                t[p] = s[p];
            }
        }
    }

    return t;
};

var __rest = function (s: any, e: any) {
    var t = {};

    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) {
            t[p] = s[p];
        }
    }

    if (s != null && typeof (Object as any).getOwnPropertySymbols === "function") {
        for (var i = 0, p: string = (Object as any).getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0) {
            t[p[i]] = s[p[i]];
        }
    }

    return t;
};

var __spreadArrays = function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
        s += arguments[i].length;
    }

    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
            r[k] = a[j];
        }
    }

    return r;
};